import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { INVESTORS } from '@/common/paths';

import { InvestorDto } from '../investments.types';

export default (successCallback?: (investor: InvestorDto) => void) => {
  const { isLoading, error, data, isSuccess, isError } = useQuery(
    [INVESTORS],
    () => api.get(INVESTORS),
    {
      onSuccess: (response) => {
        if (successCallback) {
          successCallback(response.data as unknown as InvestorDto);
        }
        return response;
      },
      cacheTime: 2,
    }
  );

  return {
    data,
    error,
    isError,
    isLoading,
    isSuccess,
  };
};
